import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store/state";
import { ShareType } from "../../../types/Enums";
import { CauseArea } from "../../../types/CauseArea";
export const useAmountCalculation = (selectionType, selectedCauseAreaId, causeAreas) => {
  const $ = _c(53);
  const {
    causeAreaAmounts: t0,
    orgAmounts: t1,
    causeAreaDistributionType: t2,
    operationsConfig,
    smartDistributionTotal: t3
  } = useSelector(_temp);
  let t4;
  if ($[0] !== t0) {
    t4 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const causeAreaAmounts = t4;
  let t5;
  if ($[2] !== t1) {
    t5 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const orgAmounts = t5;
  let t6;
  if ($[4] !== t2) {
    t6 = t2 === undefined ? {} : t2;
    $[4] = t2;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const causeAreaDistributionType = t6;
  const smartDistributionTotal = t3 === undefined ? 0 : t3;
  const OPERATIONS_CAUSE_AREA_ID = operationsConfig?.operationsCauseAreaId;
  let t7;
  if ($[6] !== OPERATIONS_CAUSE_AREA_ID || $[7] !== causeAreaAmounts || $[8] !== causeAreaDistributionType || $[9] !== causeAreas || $[10] !== orgAmounts || $[11] !== selectedCauseAreaId || $[12] !== selectionType) {
    t7 = Object.keys(causeAreaAmounts).reduce((acc, key) => {
      const causeAreaId = parseInt(key);
      if (causeAreaId === OPERATIONS_CAUSE_AREA_ID) {
        return acc;
      }
      if (selectionType === "single" && selectedCauseAreaId !== causeAreaId) {
        return acc;
      }
      let amountForThisCauseArea = 0;
      if (causeAreaDistributionType[causeAreaId] === ShareType.CUSTOM) {
        const currentCauseArea = causeAreas.find(ca => ca.id === causeAreaId);
        if (currentCauseArea) {
          amountForThisCauseArea = currentCauseArea.organizations.reduce((orgSum, org) => orgSum + (Number(orgAmounts[org.id]) || 0), 0);
        }
      } else {
        amountForThisCauseArea = Number(causeAreaAmounts[causeAreaId]) || 0;
      }
      return acc + amountForThisCauseArea;
    }, 0);
    $[6] = OPERATIONS_CAUSE_AREA_ID;
    $[7] = causeAreaAmounts;
    $[8] = causeAreaDistributionType;
    $[9] = causeAreas;
    $[10] = orgAmounts;
    $[11] = selectedCauseAreaId;
    $[12] = selectionType;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const sumOfOtherCauseAreas = t7;
  let currentTotal = 0;
  if (selectedCauseAreaId === -1) {
    let t8;
    if ($[14] !== OPERATIONS_CAUSE_AREA_ID || $[15] !== causeAreaAmounts || $[16] !== causeAreaDistributionType || $[17] !== causeAreas || $[18] !== orgAmounts) {
      let t9;
      if ($[20] !== OPERATIONS_CAUSE_AREA_ID || $[21] !== causeAreaAmounts || $[22] !== causeAreaDistributionType || $[23] !== orgAmounts) {
        t9 = (acc_0, area) => {
          if (causeAreaDistributionType[area.id] === ShareType.CUSTOM && area.id !== OPERATIONS_CAUSE_AREA_ID) {
            return acc_0 + area.organizations.reduce((orgAcc, org_0) => orgAcc + (orgAmounts[org_0.id] || 0), 0);
          }
          return acc_0 + (causeAreaAmounts[area.id] || 0);
        };
        $[20] = OPERATIONS_CAUSE_AREA_ID;
        $[21] = causeAreaAmounts;
        $[22] = causeAreaDistributionType;
        $[23] = orgAmounts;
        $[24] = t9;
      } else {
        t9 = $[24];
      }
      t8 = causeAreas.reduce(t9, 0);
      $[14] = OPERATIONS_CAUSE_AREA_ID;
      $[15] = causeAreaAmounts;
      $[16] = causeAreaDistributionType;
      $[17] = causeAreas;
      $[18] = orgAmounts;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    currentTotal = t8;
  } else {
    if (selectionType === "multiple") {
      let t8;
      if ($[25] !== OPERATIONS_CAUSE_AREA_ID || $[26] !== causeAreaAmounts || $[27] !== causeAreaDistributionType || $[28] !== causeAreas || $[29] !== orgAmounts) {
        let t9;
        if ($[31] !== OPERATIONS_CAUSE_AREA_ID) {
          t9 = ca_0 => ca_0.id !== 5 && ca_0.id !== OPERATIONS_CAUSE_AREA_ID;
          $[31] = OPERATIONS_CAUSE_AREA_ID;
          $[32] = t9;
        } else {
          t9 = $[32];
        }
        let t10;
        if ($[33] !== causeAreaAmounts || $[34] !== causeAreaDistributionType || $[35] !== orgAmounts) {
          t10 = (acc_1, area_0) => {
            if (causeAreaDistributionType[area_0.id] === ShareType.CUSTOM) {
              return acc_1 + area_0.organizations.reduce((orgAcc_0, org_1) => orgAcc_0 + (orgAmounts[org_1.id] || 0), 0);
            }
            return acc_1 + (causeAreaAmounts[area_0.id] || 0);
          };
          $[33] = causeAreaAmounts;
          $[34] = causeAreaDistributionType;
          $[35] = orgAmounts;
          $[36] = t10;
        } else {
          t10 = $[36];
        }
        t8 = causeAreas.filter(t9).reduce(t10, 0);
        $[25] = OPERATIONS_CAUSE_AREA_ID;
        $[26] = causeAreaAmounts;
        $[27] = causeAreaDistributionType;
        $[28] = causeAreas;
        $[29] = orgAmounts;
        $[30] = t8;
      } else {
        t8 = $[30];
      }
      currentTotal = t8;
      currentTotal = currentTotal + smartDistributionTotal;
    } else {
      if (selectionType === "single" && selectedCauseAreaId != null) {
        if ($[37] !== causeAreaAmounts || $[38] !== causeAreaDistributionType || $[39] !== causeAreas || $[40] !== orgAmounts || $[41] !== selectedCauseAreaId) {
          let t8;
          if ($[43] !== selectedCauseAreaId) {
            t8 = area_1 => area_1.id === selectedCauseAreaId;
            $[43] = selectedCauseAreaId;
            $[44] = t8;
          } else {
            t8 = $[44];
          }
          const selectedArea = causeAreas.find(t8);
          if (selectedArea) {
            if (causeAreaDistributionType[selectedCauseAreaId] === ShareType.STANDARD) {
              currentTotal = 0 + (causeAreaAmounts[selectedCauseAreaId] || 0);
            } else {
              let t9;
              if ($[45] !== orgAmounts) {
                t9 = (orgAcc_1, org_2) => orgAcc_1 + (orgAmounts[org_2.id] || 0);
                $[45] = orgAmounts;
                $[46] = t9;
              } else {
                t9 = $[46];
              }
              currentTotal = 0 + selectedArea.organizations.reduce(t9, 0);
            }
          }
          $[37] = causeAreaAmounts;
          $[38] = causeAreaDistributionType;
          $[39] = causeAreas;
          $[40] = orgAmounts;
          $[41] = selectedCauseAreaId;
          $[42] = currentTotal;
        } else {
          currentTotal = $[42];
        }
      }
    }
  }
  const totalAmount = currentTotal;
  let t8;
  if ($[47] !== causeAreaAmounts || $[48] !== causeAreaDistributionType || $[49] !== orgAmounts || $[50] !== sumOfOtherCauseAreas || $[51] !== totalAmount) {
    t8 = {
      sumOfOtherCauseAreas,
      totalAmount,
      causeAreaAmounts,
      orgAmounts,
      causeAreaDistributionType
    };
    $[47] = causeAreaAmounts;
    $[48] = causeAreaDistributionType;
    $[49] = orgAmounts;
    $[50] = sumOfOtherCauseAreas;
    $[51] = totalAmount;
    $[52] = t8;
  } else {
    t8 = $[52];
  }
  return t8;
};
function _temp(state) {
  return state.donation;
}